import { PlaceService } from '@/services/PlaceService';
import { useQuery } from '@tanstack/react-query';

interface UseStaticMapUrlProps {
  address?: string | null;
  enabled?: boolean;
  size?: string;
  zoom?: string;
  maptype?: string;
}

export const useStaticMapUrl = ({
  address,
  enabled = true,
  size = '400x300',
  zoom = '15',
  maptype = 'roadmap',
}: UseStaticMapUrlProps) => {
  return useQuery({
    queryKey: ['static-map-url', address, size, zoom, maptype],
    queryFn: () => {
      if (!address) throw new Error('Address is required');
      return PlaceService.getStaticMapUrl(address, size, zoom, maptype);
    },
    enabled: enabled && !!address && address.trim().length > 0,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};
